import React from "react";
import Card from "./Card";
import HeroSection from "./HeroSection";
import Breadcrumb from "./Breadcrumb";
function Panel() {
  return (
    <div className="aboutInfo">
      <div>
        {/* Reusable Hero Section */}
        <HeroSection
          heading="Interactive Display Panel"
          backgroundImage="/img/panel1.png"
        />

        <Breadcrumb current="Embedded" />

        {/* Features Section */}
        <div className="container about">
          <div className="row">
            <div className="col-md-6 ">
              <img alt="about" src="./img/television.png" className="panel-img" />
            </div>
            <div className="col-md-6">
              <h2 className="block-h4">FEATURES</h2>
              <ul className="points-list">
                <li>5 in 1 motherboard, stable performance</li>
                <li>Zero gap bonding technology, low parallax writing and wider viewing angles</li>
                <li>3mm anti-glare toughened glass with high haze OC for clearer display against ambient light interference</li>
                <li>Light-sensitive brightness adjustment (Optional)</li>
                <li>4K Ultra HD display, support full channel 4K UI display</li>
                <li>Front Type C*1 + USB3.0*2 + HDMI Input*1 + Touch USB*1, supports switching with channels</li>
                <li>Support for Wireless projection</li>
                <li>±1mm High precision infrared touch control for smooth writing</li>
                <li>Supports dual pens and dual colour displays for easy multi-person collaboration</li>
                <li>Wi-Fi6 (Optional), dual-band 2.4G/5G, AP+STA operating mode</li>
                <li>One network support Android and OPS (Optional)</li>
                <li>Split screen, parallel tasks and wider scenes</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Cards Section */}
        <div className="container services">
          <div className="card-cover">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-4 mb-2">
                    <Card
                      title="86 inch Flat Panel"
                      img="panel.png"
                      showButton={true}
                      buttonLabel="Download Brochure"
                      onClick={() =>
                        window.open("/pdf/86-inch.pdf", "_blank")
                      }
                    />
                </div>
                <div className="col-md-4 mb-2">
                    <Card
                      title="75 inch Flat Panel"
                      img="panel.png"
                      showButton={true}
                      buttonLabel="Download Brochure"
                      onClick={() =>
                        window.open("/pdf/75-inch.pdf", "_blank")
                      }
                    />
                </div>
                <div className="col-md-4 mb-2">
                    <Card
                      title="65 inch Flat Panel"
                      img="panel.png"
                      showButton={true}
                      buttonLabel="Download Brochure"
                      onClick={() =>
                        window.open("/pdf/65-inch.pdf", "_blank")
                      }
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Panel;
